import angkorSunrise from "@/assets/gallery/angkor-sunrise.jpg";
import angkorSunriseReflection from "@/assets/gallery/angkor-sunrise-reflection.jpg";
import apsaraDancers from "@/assets/gallery/apsara-dancers.jpg";
import taProhmTree from "@/assets/gallery/ta-prohm-tree.jpg";
import groupMeal from "@/assets/gallery/group-meal.jpg";
import floatingVillage from "@/assets/gallery/floating-village.jpg";
import floatingMarketVendor from "@/assets/gallery/floating-market-vendor.jpg";
import floatingHouse from "@/assets/gallery/floating-house.jpg";
import stiltHouses from "@/assets/gallery/stilt-houses.jpg";
import villageBoats from "@/assets/gallery/village-boats.jpg";
import lakesideChild from "@/assets/gallery/lakeside-child.jpg";
import villageChildren from "@/assets/gallery/village-children.jpg";
import wavingGirl from "@/assets/gallery/waving-girl.jpg";
import dryingFish from "@/assets/gallery/drying-fish.jpg";
import fishVendor from "@/assets/gallery/fish-vendor.jpg";
import oxCartTour from "@/assets/gallery/ox-cart-tour.jpg";
import familyBoatVillage from "@/assets/gallery/family-boat-village.jpg";
import greenBoatChildren from "@/assets/gallery/green-boat-children.jpg";
import stiltVillageSkyline from "@/assets/gallery/stilt-village-skyline.jpg";
import floodedForestTrees from "@/assets/gallery/flooded-forest-trees.jpg";
import kampongPhlukStilts from "@/assets/gallery/kampong-phluk-stilts.jpg";
import khmerWoodenHouseDogs from "@/assets/gallery/khmer-wooden-house-dogs.jpg";
import yellowBoatTravelers from "@/assets/gallery/yellow-boat-travelers.jpg";
import taProhmCoupleTree from "@/assets/gallery/ta-prohm-couple-tree.jpg";
import pepperFarmTour from "@/assets/gallery/pepper-farm-tour.jpg";
import guidesGreeting from "@/assets/gallery/guides-greeting.jpg";
import forestTrailWalk from "@/assets/gallery/forest-trail-walk.jpg";
import kulenFlagViewpoint from "@/assets/gallery/kulen-flag-viewpoint.jpg";
import oxcartVillageRide from "@/assets/gallery/oxcart-village-ride.jpg";
import tuktukRide from "@/assets/gallery/tuktuk-ride.jpg";
import riceFieldGuide from "@/assets/gallery/rice-field-guide.jpg";
import buggyForestPath from "@/assets/gallery/buggy-forest-path.jpg";

const photos = [
  { src: angkorSunriseReflection, alt: "Angkor Wat at sunrise reflected in the lotus pond" },
  { src: apsaraDancers, alt: "Traditional Apsara dancers performing in golden costume" },
  { src: taProhmTree, alt: "Giant tree roots over Ta Prohm temple" },
  { src: taProhmCoupleTree, alt: "Travelers beneath a towering silk-cotton tree at Ta Prohm" },
  { src: kulenFlagViewpoint, alt: "Travelers posing with Cambodian flags at a Phnom Kulen viewpoint" },
  { src: floatingMarketVendor, alt: "Floating market vendor selling fruit from a boat at Kampong Phluk" },
  { src: stiltHouses, alt: "Towering stilt houses of a Tonlé Sap village" },
  { src: kampongPhlukStilts, alt: "Tall stilt houses and wooden boats at Kampong Phluk" },
  { src: stiltVillageSkyline, alt: "Stilt-house village skyline along the Tonlé Sap" },
  { src: wavingGirl, alt: "Cambodian girl waving from a wooden balcony" },
  { src: floatingHouse, alt: "Floating house drifting on the Tonlé Sap lake" },
  { src: villageBoats, alt: "Colorful wooden boats moored at a stilt village" },
  { src: familyBoatVillage, alt: "Family rowing a wooden boat past floating houses" },
  { src: greenBoatChildren, alt: "Children paddling a green boat through a floating village" },
  { src: yellowBoatTravelers, alt: "Travelers smiling aboard a bright yellow river boat" },
  { src: floodedForestTrees, alt: "Towering trees rising from the flooded forest of Tonlé Sap" },
  { src: angkorSunrise, alt: "Sunrise at Angkor Wat with naga balustrade" },
  { src: pepperFarmTour, alt: "Group touring a Kampot pepper farm under shade nets" },
  { src: guidesGreeting, alt: "Khmer guides warmly greeting French-speaking travelers" },
  { src: riceFieldGuide, alt: "Local guide explaining rice fields to a small group of travelers" },
  { src: forestTrailWalk, alt: "Travelers walking a shaded forest trail in Cambodia" },
  { src: oxcartVillageRide, alt: "Travelers boarding a traditional ox cart in a Khmer village" },
  { src: oxCartTour, alt: "Travelers riding a traditional Khmer ox cart through the countryside" },
  { src: buggyForestPath, alt: "Buggy ride along a tree-lined countryside path" },
  { src: tuktukRide, alt: "Tuk-tuk driver taking travelers along a Siem Reap road" },
  { src: khmerWoodenHouseDogs, alt: "Traditional Khmer wooden stilt house at golden hour with village dogs" },
  { src: lakesideChild, alt: "Child walking past a lakeside home in the floodplain" },
  { src: floatingVillage, alt: "Floating village fishermen on the Tonlé Sap" },
  { src: groupMeal, alt: "Group of travelers sharing a Khmer meal" },
  { src: dryingFish, alt: "Racks of fish drying in a lakeside village" },
  { src: villageChildren, alt: "Smiling children in a Cambodian village" },
  { src: fishVendor, alt: "Local woman tending to drying fish" },
];

const Gallery = () => (
  <section id="gallery" className="bg-background py-28 md:py-36">
    <div className="container">
      <div className="flex items-end justify-between mb-16">
        <div>
          <p className="text-xs uppercase tracking-[0.4em] text-primary mb-5">— Gallery</p>
          <h2 className="font-display text-4xl md:text-6xl">Moments from the journey.</h2>
        </div>
        <a
          href="#contact"
          className="hidden md:inline-block text-[11px] uppercase tracking-[0.3em] border-b border-foreground/40 pb-1 hover:text-primary hover:border-primary transition-colors"
        >
          Plan your own →
        </a>
      </div>

      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-5 gap-3 md:gap-4">
        {photos.slice(0, 10).map((photo, i) => (
          <figure
            key={i}
            className="relative aspect-[3/4] overflow-hidden bg-secondary group"
          >
            <img
              src={photo.src}
              alt={photo.alt}
              loading={i < 5 ? "eager" : "lazy"}
              decoding="async"
              className="absolute inset-0 h-full w-full object-cover transition-transform duration-[1200ms] ease-out group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-foreground/40 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
          </figure>
        ))}
      </div>
    </div>
  </section>
);

export default Gallery;
